$(document).ready(function () {
  const counter = $(".counter");
  const oldDateInteger = 1700730836602;
  const currentDateInteger = Date.now();
  const dayCount = Math.floor((currentDateInteger - oldDateInteger) / 1000 / 3600 / 24);

  if (counter) {
    const oldCustomerCount = counter.text();
    let customerCount;

    if (dayCount >= 1) {
      customerCount = parseInt(oldCustomerCount) + Math.floor(197 * dayCount);
    } else {
      customerCount = oldCustomerCount;
    }

    counter.text(customerCount);
  }
});
